module.exports = __webpack_public_path__ + "img/3.3b7399f7.jpg";